import { useBooleanFlagValue } from '@openfeature/react-sdk'
import { OrderStatus } from '@planning/app/api'
import { useOrderNavigation } from '@planning/hooks/useOrderNavigation'
import { useVesselVisitTableMenuOptions } from '@planning/hooks/useVesselVisitTableMenuOptions'
import { IContainerJourneyItem } from '@planning/pages/Issues/Stores/ContainerJourneyItem'
import { useTranslate } from '@tolgee/react'
import { ButtonOption, OptionsButton } from '@tom-ui/ui'
import { authStore } from '@tom-ui/utils'
import { FC, useMemo } from 'react'
import { useUpdateOrderStowagePosition } from '../../Hooks/useUpdateOrderStowagePosition'

type Props = {
  journey?: IContainerJourneyItem
}

export const RestowListMenuOptions: FC<Props> = ({ journey }) => {
  const { t } = useTranslate()
  const { openEditOrder } = useOrderNavigation()
  const { onOrderHistory } = useVesselVisitTableMenuOptions()
  const isContainerHistoryTurnedOn = useBooleanFlagValue('container-history', false)
  const { onEditPostion } = useUpdateOrderStowagePosition()

  const actions: ButtonOption[] = useMemo(() => {
    const inboundOrder = journey?.inboundOrder?.data
    const outboundOrder = journey?.outboundOrder?.data

    if (!inboundOrder) {
      return []
    }
    const editPlannedPositionTitle = t('editPlannedPosition', 'Edit planned position')
    const actions: ButtonOption[] = [
      {
        label: t('viewDetails', 'View details'),
        onClick: () => openEditOrder(inboundOrder, 'restow'),
      },
      {
        label: editPlannedPositionTitle,
        disabled: journey?.outboundOrder && journey.outboundOrderStatus === OrderStatus.Fulfilled,
        onClick: () => onEditPostion(editPlannedPositionTitle, outboundOrder),
      },
    ]

    if (isContainerHistoryTurnedOn) {
      actions.push({
        label: t('history', 'History'),
        onClick: () => onOrderHistory(inboundOrder.containerId!, inboundOrder.carrierVisitId),
      })
    }

    const isAdmin = authStore.isAdmin()

    if (isAdmin) {
      const editOutboundPositionTitle = t('editOutboundPosition', 'Edit outbound position')
      actions.push({
        label: t('admin', 'Admin'),
        children: [
          {
            label: editOutboundPositionTitle,
            disabled: !journey?.outboundOrder || journey.outboundOrderStatus === OrderStatus.Open,
            onClick: () => onEditPostion(editOutboundPositionTitle, outboundOrder),
          },
        ],
      })
    }

    return actions
  }, [journey, t, openEditOrder, onEditPostion, onEditPostion, isContainerHistoryTurnedOn])
  return !!actions?.length && <OptionsButton options={actions} position='right' />
}
